import {
 FormLabel,
 Stack,
 Text,
 Flex,
 Tooltip,
 Image,
 RadioGroup,
 Radio,
} from '@chakra-ui/react';
import { InputText } from '../../components/Input';
import { info } from '../../assets/new-images/icons';
import React, { useCallback } from 'react';

function OptionsComponent({
 index,
 register,
 options,
 errors,
 isCheckboxSelected,
 certificationPrerequisite,
}) {
 //  const showPrerequisiteOptions =
 //   isCheckboxSelected && certificationPrerequisite === 'Sim';

 const showPrerequisiteOptions = useCallback(
  () => isCheckboxSelected && certificationPrerequisite === 'Sim',
  [isCheckboxSelected, certificationPrerequisite]
 );

 const renderTooltip = useCallback(
  (label, description) => (
   <Flex gap='4px' align='center' w={label === 'Pré-requisito' ? '123px' : '134px'}>
    <Text fontWeight={600}>{label}</Text>
    <Tooltip
     hasArrow
     label={description}
     bg='#CCCFD1'
     color='black.100'
     textAlign='center'
     minW='417px'
     p='8px 16px'
     borderRadius='4px'
    >
     <span>
      <Image src={info} alt='' w='18px' />
     </span>
    </Tooltip>
   </Flex>
  ),
  []
 );
 return (
  <Stack spacing='6'>
   <Flex h='20px' gap='6' justify='space-between'>
    <Text fontWeight={600}>Opções de resposta</Text>

    {showPrerequisiteOptions() && (
     <Flex gap='6'>
      {renderTooltip(
       'Eliminatória',
       'Caso haja alguma alternativa que seja obrigatória a empresa selecionar para ser certificada, marque o checkbox.'
      )}
      {renderTooltip(
       'Não pontua',
       'Caso haja alguma alternativa que não deva ser contabilizada na nota, marque o checkbox.'
      )}
     </Flex>
    )}
   </Flex>

   <Stack spacing='12px' py='2px'>
    {options?.map((option, i) => (
     <Flex key={option.id} align='center' gap={6}>
      <FormLabel
       htmlFor={`form.${index}.options.${i}.description`}
       fontSize='16px'
       m={0}
       fontWeight={600}
       lineHeight='18.78px'
      >
       {i < 9 ? `0${i + 1}` : i + 1}
      </FormLabel>
      <InputText
       {...register(`form.${index}.options.${i}.description`)}
       error={errors?.form?.[index]?.options?.[i]?.description}
       placeholder='Digite a alternativa'
      />

      {showPrerequisiteOptions() && (
       <Flex gap='6' className='prerequisite_radio_options'>
        {/* <Radio {...register(`form.${index}.options.${i}.isPrerequisite`)}
         type='radio'
         value='Sim'
         id={`form.${index}.options.${i}.isPrerequisite_yes`} />
       
       <Radio {...register(`form.${index}.options.${i}.isPrerequisite`)}
         type='radio'
         value='Não'
         id={`form.${index}.options.${i}.isPrerequisite_`} /> */}
        <Flex w='123px' align='center' justify='center'>
         <input
          {...register(`form.${index}.options.${i}.isPrerequisite`)}
          type='radio'
          value='Sim'
          id={`form.${index}.options.${i}.isPrerequisite_yes`}
         />
        </Flex>
        <Flex w='134px' align='center' justify='center'>
         <input
          {...register(`form.${index}.options.${i}.isPrerequisite`)}
          type='radio'
          value='Não'
          id={`form.${index}.options.${i}.isPrerequisite_no`}
         />
        </Flex>
       </Flex>
      )}
     </Flex>
    ))}
   </Stack>
  </Stack>
 );
}

const Options = React.memo(OptionsComponent);
export default Options;
